import { AppState } from "../../../states";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { CustomerContactsActions } from "../../states/Contacts/CustomerContactsState";
import { CustomersContactsList } from "./CustomersContactsList";
import { User } from "../../states/WorkspacesState";

export interface StateToProps {
  contacts: any[];
  searchString: string;
  incomingCounters: any;
  selectedWorkspace: User | null;
}

export interface DispatchToProps {
  setActiveContact: (contact: any, index: number) => void;
  typeSearch: (phrase: string) => void;
  loadContacts: (contacts: any[]) => void;
}

const mapStateToProps = (state: AppState): StateToProps => ({
  contacts: state["call-center"].cmnc_cust_contacts.contacts,
  searchString: state["call-center"].cmnc_cust_contacts.serachPhrase,
  incomingCounters: state["call-center"].cmnc_cust_contacts.incomingCounters,
  selectedWorkspace: state["call-center"].cmnc_users.selectedWorkspace,
});

const mapDispatchToProps = (dispatch: Dispatch<any>): DispatchToProps => ({
  setActiveContact: bindActionCreators(
    CustomerContactsActions.setActiveContact,
    dispatch
  ),
  typeSearch: bindActionCreators(CustomerContactsActions.typeSearch, dispatch),
  loadContacts: bindActionCreators(
    CustomerContactsActions.loadContacts,
    dispatch
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomersContactsList);
